(function () {
  var TRANSITION_KEY = "hanaleiPageTransition";
  var body = document.body;
  if (!body) return;

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var isAllCottagesPage = body.classList.contains("page-all-cottages");
  var isCottageDetailPage = body.classList.contains("page-cottage-detail");

  var cottagePaths = {
    "/pages/cottage-one": true,
    "/pages/cottage-two": true,
    "/pages/cottage-three": true,
    "/pages/cottage-four": true
  };

  function normalizePath(path) {
    if (!path) return "/";
    var normalized = path.replace(/\/+$/, "");
    return normalized || "/";
  }

  function hydrateTransitionLogo() {
    var coverLogo = document.querySelector(".page-transition-cover__logo");
    if (!coverLogo) return;

    var headerLogo = document.querySelector(".header__logo-image--mobile");
    if (!headerLogo) return;

    var src = headerLogo.getAttribute("src");
    var srcset = headerLogo.getAttribute("srcset");
    if (!src) return;

    coverLogo.setAttribute("src", src);
    if (srcset) {
      coverLogo.setAttribute("srcset", srcset);
    }
    coverLogo.classList.add("is-ready");

    try {
      sessionStorage.setItem(
        "hanaleiPageTransitionLogo",
        JSON.stringify({
          src: src,
          srcset: srcset || ""
        })
      );
    } catch (error) {}

    var existingPreload = document.querySelector(
      'link[rel="preload"][as="image"][data-transition-logo="true"]'
    );
    if (!existingPreload) {
      var preload = document.createElement("link");
      preload.rel = "preload";
      preload.as = "image";
      preload.href = src;
      preload.setAttribute("data-transition-logo", "true");
      if (srcset) {
        preload.setAttribute("imagesrcset", srcset);
      }
      document.head.appendChild(preload);
    }
  }

  hydrateTransitionLogo();

  function prefetchPath(path) {
    var href = window.location.origin + path;
    if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;

    var link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "document";
    link.href = href;
    document.head.appendChild(link);
  }

  function tryPrefetchFromEventTarget(target) {
    if (!isAllCottagesPage || !target) return;

    var link = target.closest("a[href]");
    if (!link) return;

    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    var targetPath = normalizePath(url.pathname);
    if (!cottagePaths[targetPath]) return;
    prefetchPath(targetPath);
  }

  if (isAllCottagesPage) {
    document.addEventListener(
      "mouseover",
      function (event) {
        tryPrefetchFromEventTarget(event.target);
      },
      true
    );
    document.addEventListener(
      "focusin",
      function (event) {
        tryPrefetchFromEventTarget(event.target);
      },
      true
    );
    document.addEventListener(
      "touchstart",
      function (event) {
        tryPrefetchFromEventTarget(event.target);
      },
      { capture: true, passive: true }
    );
  }

  if (isCottageDetailPage) {
    if (prefersReducedMotion) {
      body.classList.add("is-page-entered");
      try {
        sessionStorage.removeItem(TRANSITION_KEY);
      } catch (error) {}
    } else {
      body.classList.add("is-page-entering");
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          body.classList.add("is-page-entered");
          try {
            sessionStorage.removeItem(TRANSITION_KEY);
          } catch (error) {}
        });
      });
    }
  }

  if (!isAllCottagesPage || prefersReducedMotion) return;

  document.addEventListener(
    "click",
    function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var link = event.target.closest("a[href]");
      if (!link) return;
      if (link.hasAttribute("download")) return;
      if (link.target && link.target.toLowerCase() !== "_self") return;

      var href = link.getAttribute("href");
      if (!href || href.charAt(0) === "#") return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      var targetPath = normalizePath(url.pathname);
      if (!cottagePaths[targetPath]) return;

      event.preventDefault();

      try {
        sessionStorage.setItem(
          TRANSITION_KEY,
          JSON.stringify({
            path: url.pathname,
            ts: Date.now()
          })
        );
      } catch (error) {}

      body.classList.add("is-page-leaving");

      window.location.assign(url.href);
    },
    true
  );
})();
